import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { useModal } from '../helpers/ModalContext';
import { useAlert } from '../helpers/AlertContext'; // import alert context

export default function DashboardSlider({ game }) {
    const { openModal } = useModal();
    const { showAlert } = useAlert();
    const [isFav, setIsFav] = useState(false);
    const key = 'GF_Favorites';


      useEffect(() => {
        if (window.AOS) {
          window.AOS.init({ duration: 500 });
        }
      }, []);


    useEffect(() => {
        const stored = localStorage.getItem(key);
        const favorites = stored ? JSON.parse(stored) : [];
        const exists = favorites.some(fav => fav.ID === game.ID);
        setIsFav(exists);

    }, [game.ID]);

    function toggleFavorite(game) {
        const stored = localStorage.getItem(key);
        let favorites = stored ? JSON.parse(stored) : [];

        const exists = favorites.some(fav => fav.ID === game.ID);

        if (exists) {
            favorites = favorites.filter(fav => fav.ID !== game.ID);
            localStorage.setItem(key, JSON.stringify(favorites));
            setIsFav(false);
            showAlert('Game removed from favorites.');
        } else {
            favorites.push(game);
            localStorage.setItem(key, JSON.stringify(favorites));
            setIsFav(true);
            showAlert('Game added to favorites.');
        }
    }

    return (
        <div className='dashboard_slider_item' data-aos="zoom-out" >
            <img src={game.Thumbnail_Large} alt={game.Title} />

            <div className='dashboard_slider_inner'>
                <p>{game.Category[0]}</p>
                <h3>{game.Title}</h3>

                <div className='d-flex flex-row align-items-center gap-1'>
                    <button className='btn btn-primary' onClick={() => openModal(game)}>Play Now</button>
                    <Star
                        color={isFav ? '#FFD700' : 'white'} // filled if in favorites
                        fill={isFav ? '#FFD700' : 'none'}
                        size={35}
                        onClick={() => toggleFavorite(game)}
                        style={{
                            backgroundColor: 'grey',
                            borderRadius: '20px',
                            padding: '5px 5px 5px 6px',
                            cursor: 'pointer'
                        }}
                    />
                </div>

                <div className='my-3' style={{ width: '100%', borderTop: '0.5px solid #c0c0c0' }}></div>

                <p>{game.Description}</p>
            </div>
        </div>
    );
}
